import React from 'react';
import styled from 'styled-components';

import content from '../content';

import Article from './Article';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const Content = () => {
  const { articles } = content;

  return (
    <Container>
      {articles.map((article, i) => (
        <Article key={i} {...article}></Article>
      ))}
    </Container>
  )
}

export default Content;